module.exports = __webpack_public_path__ + "assets/cynergy-logo-white.040aefc8.svg";